<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-text`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M41 6a1 1 0 011 1v2a1 1 0 01-1 1H26v31a1 1 0 01-1 1h-2a1 1 0 01-1-1V9.999L7 10a1 1 0 01-1-1V7a1 1 0 011-1h34z"/></svg>
</template>
<script>

export default {
  name: 'IconText',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
